// import React from "react";
// import { motion } from "framer-motion";
// import { useSelector } from "react-redux";

// const ProfilePage = () => {

//   const user = useSelector((state) => state.user.user);

//   return (
//     <div className="bg-[#f6f6f6] min-h-screen py-10 px-4">

//       <div className="max-w-6xl mx-auto">

//         {/* HEADER */}
//         <motion.div
//           initial={{ opacity: 0, y: -30 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="bg-white rounded-2xl p-6 shadow-sm flex items-center gap-6"
//         >

//           {/* AVATAR */}
//           <div className="w-20 h-20 rounded-full bg-black text-white flex items-center justify-center text-2xl font-semibold">
//             {user?.name?.charAt(0) || "U"}
//           </div>

//           {/* INFO */}
//           <div>
//             <h2 className="text-xl font-semibold">
//               {user?.name || "User Name"}
//             </h2>

//             <p className="text-gray-500 text-sm">
//               {user?.email || "user@email.com"}
//             </p>
//           </div>

//         </motion.div>

//         {/* GRID SECTION */}
//         <div className="grid md:grid-cols-2 gap-6 mt-8">

//           {/* ORDERS */}
//           <motion.div
//             whileHover={{ scale: 1.02 }}
//             className="bg-white p-6 rounded-2xl shadow-sm cursor-pointer"
//           >
//             <h3 className="text-lg font-semibold mb-3">
//               My Orders
//             </h3>

//             <p className="text-gray-500 text-sm">
//               Track, return or buy things again
//             </p>

//             <button className="mt-4 text-blue-600 text-sm">
//               View Orders →
//             </button>
//           </motion.div>

//           {/* ADDRESS */}
//           <motion.div
//             whileHover={{ scale: 1.02 }}
//             className="bg-white p-6 rounded-2xl shadow-sm cursor-pointer"
//           >
//             <h3 className="text-lg font-semibold mb-3">
//               Addresses
//             </h3>

//             <p className="text-gray-500 text-sm">
//               Manage your delivery addresses
//             </p>

//             <button className="mt-4 text-blue-600 text-sm">
//               Manage Addresses →
//             </button>
//           </motion.div>

//           {/* ACCOUNT SETTINGS */}
//           <motion.div
//             whileHover={{ scale: 1.02 }}
//             className="bg-white p-6 rounded-2xl shadow-sm cursor-pointer"
//           >
//             <h3 className="text-lg font-semibold mb-3">
//               Account Settings
//             </h3>

//             <p className="text-gray-500 text-sm">
//               Update your profile & password
//             </p>

//             <button className="mt-4 text-blue-600 text-sm">
//               Edit Profile →
//             </button>
//           </motion.div>

//           {/* LOGOUT */}
//           <motion.div
//             whileHover={{ scale: 1.02 }}
//             className="bg-red-50 p-6 rounded-2xl shadow-sm cursor-pointer"
//           >
//             <h3 className="text-lg font-semibold mb-3 text-red-600">
//               Logout
//             </h3>

//             <p className="text-gray-500 text-sm">
//               Sign out from your account
//             </p>

//             <button className="mt-4 text-red-600 text-sm">
//               Logout →
//             </button>
//           </motion.div>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default ProfilePage;
import React from "react";
import { motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../store/userSlice";

const ProfilePage = () => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutUser());
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="p-2 md:p-4">

      {/* USER CARD */}
      <div className="bg-white rounded-2xl shadow p-4 md:p-6 flex items-center gap-4">

        <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-black text-white flex items-center justify-center text-lg font-bold">
          {user?.name?.charAt(0) || "U"}
        </div>

        <div>
          <h2 className="text-lg md:text-xl font-semibold">
            {user?.name}
          </h2>
          <p className="text-gray-500 text-sm">
            {user?.email}
          </p>
        </div>

      </div>

      {/* ACTION CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">

        <div
          onClick={() => navigate("/account/orders")}
          className="bg-white p-4 rounded-xl shadow hover:shadow-md cursor-pointer"
        >
          <h3 className="font-semibold">My Orders</h3>
          <p className="text-sm text-gray-500">
            Track your orders
          </p>
        </div>

        <div
          onClick={() => navigate("/account/address")}
          className="bg-white p-4 rounded-xl shadow hover:shadow-md cursor-pointer"
        >
          <h3 className="font-semibold">Addresses</h3>
          <p className="text-sm text-gray-500">
            Manage address
          </p>
        </div>

        <div className="bg-white p-4 rounded-xl shadow">
          <h3 className="font-semibold">Account Settings</h3>
          <p className="text-sm text-gray-500">
            Update profile
          </p>
        </div>

        <div
          onClick={handleLogout}
          className="bg-red-50 p-4 rounded-xl shadow cursor-pointer"
        >
          <h3 className="font-semibold text-red-600">
            Logout
          </h3>
        </div>

      </div>

    </div>
  );
};

export default ProfilePage;